module.exports = __webpack_public_path__ + "static/Vogue-7975f23d4d70921e68c8700d1a97efcf.svg";